/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable object-curly-newline */
import './JustificationDetails.css';

import {
  Icon,
  InlineMessage,
  InputField,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function JustificationDetails({
  isCritical,
  setIsCritical,
  detailsObj,
  setDetails,
}) {
  const [justification, setJustification] = useState(detailsObj.justification);
  const [ticketNumber, setTicketNumber] = useState(detailsObj.ticketNumber);
  const [attachments, setAttachments] = useState(detailsObj.attachments);

  useEffect(() => {
    setDetails({ justification, ticketNumber, attachments });
  }, [justification, ticketNumber, attachments]);

  return (
    <div className='JustificationDetails'>
      <div className='JustificationDetails-fields'>
        <InputField
          name='Justification Details'
          placeholder='Provide a reason for your request'
          label='Justification'
          backgroundColor='secondary'
          value={justification}
          setValue={setJustification}
          kind='multiline'
          isRequired
          isCritical={isCritical}
          setIsCritical={setIsCritical}
          CriticalHelperText={
            <InlineMessage
              text='This required field is incomplete'
              colorTheme='critical'
              size='small'
              leftIcon={<Icon kind='AlertCritical' color='critical-700' />}
            />
          }
        />
        <InputField
          type='number'
          name='Ticket Number'
          placeholder='Enter ticket number'
          label='Ticket Number (optional)'
          backgroundColor='secondary'
          value={ticketNumber}
          setValue={setTicketNumber}
          pattern='\d*'
        />
        <Typography kind='h3'>**Attachments not in demo. WIP**</Typography>
      </div>
    </div>
  );
}

JustificationDetails.propTypes = {
  isCritical: PropTypes.bool,
  setIsCritical: PropTypes.func,
  detailsObj: PropTypes.shape({
    justification: PropTypes.string,
    ticketNumber: PropTypes.string,
    attachments: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.instanceOf(File)),
      PropTypes.string,
    ]),
  }),
  setDetails: PropTypes.func,
};

JustificationDetails.defaultProps = {
  isCritical: false,
  setIsCritical: () => {},
  detailsObj: {
    justification: null,
    ticketNumber: null,
    attachments: null,
  },
  setDetails: () => {},
};

export default JustificationDetails;
